import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardMedia,
    Container,
    Paper,
} from "@mui/material";

import Banner from "../components/Banner";
import BenefitsRow from "../components/BenefitsRow";
import TopSellersCarousel from "../components/TopSellersCarousel";
import SobreHome from "../components/SobreHome";

const Home = () => {
    return (

        <Box sx={{ backgroundColor: "var(--backgroundPage)", pb: 10 }}>
            <Banner />
            <BenefitsRow />
            <TopSellersCarousel />
            <SobreHome />
        </Box>
    );
};

export default Home;
